import { Box, Container, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';
import type { FeaturedIconPointsProps } from '~/types/sanity/components';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';
import { FeaturedIconPoint } from './FeaturedIconPointsUtils';

export const FeaturedIconPoints: FC<Omit<FeaturedIconPointsProps, '_key' | '_type'>> = ({ heading, points }) => {
  const theme = useTheme();
  const getCompoundTestId = getCompoundTestIdGenerator('featuredIconPoints');

  return (
    <Box component="section" py={{ xs: 5, sm: 7.5 }}>
      <Container>
        <Box display="grid" gridTemplateColumns={{ xs: '1fr', md: '1fr 2fr' }} rowGap={3.75} columnGap={{ md: 3 }}>
          {/* Heading */}
          <Box>
            {heading && (
              <Typography variant="h3" component="h2" sx={{ [theme.breakpoints.down('sm')]: { fontSize: 33 } }}>
                {heading}
              </Typography>
            )}
          </Box>

          {/* Points */}
          <Box
            display="grid"
            gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, 1fr)' }}
            rowGap={2}
            columnGap={{ md: 3 }}
            data-testid={getCompoundTestId('container')}
          >
            {points.map((point) => (
              <FeaturedIconPoint key={point._key} {...point} />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
